module.exports = __webpack_public_path__ + "img/normal.f76c6669.png";